import React from 'react';
import ReactDOM from 'react-dom';

import 'bulma/css/bulma.css';
import './styles/index.scss';

import { App } from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
